import { set } from 'lodash'

/**
 * ASM-546: on an item level scoring item the first question carries the whole
 * item total and the rest carry 0 - the shape helpers.getQuestionLevelScore
 * produces for the test's points row.
 *
 * The editor renders a per-part DISPLAY value (round(itemLevelScore/partCount,
 * 2), ItemDetailWidget.js) and writes it back into the question store, so
 * without this the payload ships that fraction as the real score and it is
 * persisted as maxScore (total 2 over 3 parts => 0.67).
 *
 * Previously gated on `q.scoringDisabled`, which is only ever true on the first
 * question after a delete or reorder, so an ordinary save shipped the fraction.
 * The old `manuallyGradableQn.includes(data.type)` guard is not carried over:
 * `data` is the item document and has no top-level `type`, so it never matched.
 *
 * Shared by updateItemSaga and saveTestItemSaga so the two cannot drift; kept
 * in its own module to stay out of ducks.js's circular import graph.
 *
 * ASM-899: only overwrite Q0 when itemLevelScore is numeric. Legacy/certified
 * items can have itemLevelScoring true with no itemLevelScore field; writing
 * undefined cleared the question score and blocked save with
 * "Score needs to be set".
 *
 * @param {object} q - question draft (mutated in place, immer-style)
 * @param {number} index - question's position within the item
 * @param {object} data - outgoing item payload (itemLevelScoring/itemLevelScore)
 * @returns {object} the same question, mutated
 */
export const applyItemLevelScoreNormalisation = (q, index, data) => {
  if (index === 0) {
    if (
      data.itemLevelScoring &&
      q.validation?.unscored !== true &&
      typeof data.itemLevelScore === 'number' &&
      !Number.isNaN(data.itemLevelScore)
    ) {
      set(q, 'validation.validResponse.score', data.itemLevelScore)
    }
    /**
     * after shuffle we need to reset scoringDisabled to false for the first question
     * irrespective to itemLevelScoring
     */
    q.scoringDisabled = false
    return q
  }

  if (data.itemLevelScoring) {
    // Parts 2..N carry 0. updateItemSaga gets this from
    // reSequenceQuestionsWithWidgets, but saveTestItemSaga never calls it.
    set(q, 'validation.validResponse.score', 0)
  }

  q.scoringDisabled = !!data.itemLevelScoring
  return q
}
